module.exports = __webpack_public_path__ + "static/media/Social-Projects.aacc2262.jpg";